/* eslint-disable no-unused-vars */
import axios from 'axios/index'

import config from '../../config'
import baseAction, { actionFailed as baseActionFailed } from '../../util/action'
import consts from '../../util/consts'
import createAsyncConst from '../../util/createAsyncConst'
import { revalidateAuthenticatedUser } from '../auth/AuthActions'

// O banner global de loading (Backdrop) é muito intrusivo na página /subscription,
// que refaz várias chamadas a cada interação (addons, cartão, etc.). Aqui forçamos
// putLoading=false em todas as actions deste módulo pra não disparar o banner.
const action = (type, payload = {}, error = false) =>
  baseAction(type, payload, error, false)

const actionFailed = (type, e) => baseActionFailed(type, e, false)

export const FETCH_SUBSCRIPTION = createAsyncConst('FETCH_SUBSCRIPTION')
export const FETCH_SUBSCRIPTION_GATEWAY = createAsyncConst(
  'FETCH_SUBSCRIPTION_GATEWAY'
)
export const FETCH_SUBSCRIPTION_STATUS = createAsyncConst(
  'FETCH_SUBSCRIPTION_STATUS'
)
export const FETCH_INVOICES = createAsyncConst('FETCH_INVOICES')
export const FETCH_INVOICE = createAsyncConst('FETCH_INVOICE')
export const FETCH_ADDON_CHARGES = createAsyncConst('FETCH_ADDON_CHARGES')
export const FETCH_ADDON_CHARGE = createAsyncConst('FETCH_ADDON_CHARGE')
export const SUBMIT_SUBSCRIPTION = createAsyncConst('SUBMIT_SUBSCRIPTION')
export const CANCEL_SUBSCRIPTION = createAsyncConst('CANCEL_SUBSCRIPTION')
export const FETCH_PAYMENT_HISTORY = createAsyncConst('FETCH_PAYMENT_HISTORY')
export const STORE_CREDIT_CARD = createAsyncConst('STORE_CREDIT_CARD')
export const SHOW_CREDIT_CARD = createAsyncConst('SHOW_CREDIT_CARD')
export const DESTROY_CREDIT_CARD = createAsyncConst('DESTROY_CREDIT_CARD')
export const FETCH_MY_ADDONS = createAsyncConst('FETCH_MY_ADDONS')
export const CONTRACT_ADDON = createAsyncConst('CONTRACT_ADDON')
export const CANCEL_ADDON = createAsyncConst('CANCEL_ADDON')
export const UPDATE_ADDON_QUANTITY = createAsyncConst('UPDATE_ADDON_QUANTITY')
export const FETCH_BILLING_PROFILE = createAsyncConst('FETCH_BILLING_PROFILE')
export const UPDATE_BILLING_PROFILE = createAsyncConst('UPDATE_BILLING_PROFILE')

export function fetchPlanDetails() {
  return dispatch => {
    dispatch(action(FETCH_SUBSCRIPTION.ACTION))
    return axios
      .get(`${config.API_URL}/subscription`, {
        // params: {
        //   filters: ,
        // },
      })
      .then(resp => {
        dispatch(
          action(FETCH_SUBSCRIPTION.SUCCESS, {
            data: resp.data,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_SUBSCRIPTION, e)))
  }
}

// Estado "vivo" da assinatura direto no gateway (Pagar.me): ciclo vigente e
// próxima cobrança. Diferente de fetchPlanDetails, que reflete o estado local.
// A rota devolve 200/data:null quando ainda não há assinatura integrada — não
// é erro. Em falha real (422) apenas zeramos o dado, sem snackbar de erro, pois
// a chamada ocorre no carregamento da tela.
export function fetchSubscriptionGateway() {
  return dispatch => {
    dispatch(action(FETCH_SUBSCRIPTION_GATEWAY.ACTION))
    return axios
      .get(`${config.API_URL}/subscription/gateway`)
      .then(resp => {
        dispatch(
          action(FETCH_SUBSCRIPTION_GATEWAY.SUCCESS, {
            data: resp.data,
          })
        )
        return resp
      })
      .catch(() =>
        dispatch(action(FETCH_SUBSCRIPTION_GATEWAY.SUCCESS, { data: null }))
      )
  }
}

// Cadastro de cobrança (customer) da lavanderia direto na Pagar.me. Sem
// customer criado a rota devolve 200/data:null com o motivo em `message`. O
// payload não usa `data`/`message` na raiz de propósito: a chamada ocorre no
// carregamento da tela e não deve disparar snackbar — nem de aviso, nem de
// falha do gateway (422), que é exibida dentro do próprio card.
export function fetchBillingProfile() {
  return dispatch => {
    dispatch(action(FETCH_BILLING_PROFILE.ACTION))
    return axios
      .get(`${config.API_URL}/billing-profile`)
      .then(resp => {
        dispatch(
          action(FETCH_BILLING_PROFILE.SUCCESS, {
            profile: resp.data?.data || null,
            notice: resp.data?.message || '',
          })
        )
        return resp
      })
      .catch(e =>
        dispatch(
          action(FETCH_BILLING_PROFILE.SUCCESS, {
            profile: null,
            notice:
              e?.response?.data?.message ||
              'Erro ao consultar o cadastro de cobrança no gateway.',
          })
        )
      )
  }
}

// Só `name` e `document` são editáveis; o backend deriva type/document_type
// do documento e devolve o customer atualizado.
export function updateBillingProfile(form) {
  return dispatch => {
    dispatch(action(UPDATE_BILLING_PROFILE.ACTION))
    return axios
      .put(`${config.API_URL}/billing-profile`, form)
      .then(resp => {
        dispatch(action(UPDATE_BILLING_PROFILE.SUCCESS, { data: resp.data }))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(UPDATE_BILLING_PROFILE, e))
        return false
      })
  }
}

export function submitSubscription(form) {
  return dispatch => {
    dispatch(action(SUBMIT_SUBSCRIPTION.ACTION))
    return axios
      .post(`${config.API_URL}/subscription`, form)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_SUBSCRIPTION.SUCCESS, data))
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(SUBMIT_SUBSCRIPTION, e))
        return false
      })
  }
}

export function updateSubscriptionPlan(form) {
  return dispatch => {
    dispatch(action(SUBMIT_SUBSCRIPTION.ACTION))
    return axios
      .put(`${config.API_URL}/subscription`, form)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_SUBSCRIPTION.SUCCESS, data))
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(SUBMIT_SUBSCRIPTION, e))
        return false
      })
  }
}

export function cancelSubscription() {
  return dispatch => {
    dispatch(action(CANCEL_SUBSCRIPTION.ACTION))
    return axios
      .delete(`${config.API_URL}/subscription`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CANCEL_SUBSCRIPTION.SUCCESS, data))
        dispatch(fetchPlanDetails())
        dispatch(fetchMyAddons())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(CANCEL_SUBSCRIPTION, e))
        return false
      })
  }
}

export function updateSubscriptionPaymentMethod(form, id) {
  return dispatch => {
    dispatch(action(SUBMIT_SUBSCRIPTION.ACTION))
    return axios
      .put(`${config.API_URL}/subscription/payment-method/${id}`, form)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(SUBMIT_SUBSCRIPTION.SUCCESS, data))
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(SUBMIT_SUBSCRIPTION, e))
        return false
      })
  }
}

export function storeCard(form) {
  return dispatch => {
    dispatch(action(STORE_CREDIT_CARD.ACTION))
    return axios
      .post(`${config.API_URL}/credit-card`, form)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(STORE_CREDIT_CARD.SUCCESS, data))
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(STORE_CREDIT_CARD, e))
        return false
      })
  }
}

export function updateCard(form, id) {
  return dispatch => {
    dispatch(action(STORE_CREDIT_CARD.ACTION))
    return axios
      .put(`${config.API_URL}/credit-card/${id}`, form)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(STORE_CREDIT_CARD.SUCCESS, data))
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(STORE_CREDIT_CARD, e))
        return false
      })
  }
}

export function destroyCard(id) {
  return dispatch => {
    dispatch(action(DESTROY_CREDIT_CARD.ACTION))
    return axios
      .delete(`${config.API_URL}/credit-card/${id}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(DESTROY_CREDIT_CARD.SUCCESS, data))
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(DESTROY_CREDIT_CARD, e))
        return false
      })
  }
}

export function showCreditCard(id) {
  return dispatch => {
    dispatch(action(SHOW_CREDIT_CARD.ACTION))
    return axios
      .get(`${config.API_URL}/credit-card/${id}`)
      .then(data => {
        dispatch(action(SHOW_CREDIT_CARD.SUCCESS, data))
      })
      .catch(e => {
        dispatch(actionFailed(SHOW_CREDIT_CARD, e))
      })
  }
}

export function fetchInvoices(filters) {
  return dispatch => {
    dispatch(action(FETCH_INVOICES.ACTION))
    return axios
      .get(`${config.API_URL}/invoices`, {
        params: filters,
      })
      .then(resp => {
        dispatch(
          action(FETCH_INVOICES.SUCCESS, {
            data: resp.data,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_INVOICES, e)))
  }
}

export function fetchInvoice(id) {
  return dispatch => {
    dispatch(action(FETCH_INVOICE.ACTION))
    return axios
      .get(`${config.API_URL}/invoices/${id}`, {
        // params: {
        //   filters: ,
        // },
      })
      .then(resp => {
        dispatch(
          action(FETCH_INVOICE.SUCCESS, {
            data: resp.data,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_INVOICE, e)))
  }
}

export function reprocessInvoice(id) {
  return dispatch => {
    dispatch(action(FETCH_INVOICE.ACTION))
    return axios
      .put(`${config.API_URL}/invoice/reprocess/${id}`, {
        // params: {
        //   filters: ,
        // },
      })
      .then(resp => {
        dispatch(
          action(FETCH_INVOICE.SUCCESS, {
            data: resp.data,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_INVOICE, e)))
  }
}

// Cobranças avulsas de pró-rata (add-on contratado/aumentado no meio do ciclo).
// Não são faturas de assinatura: vivem em laundry_client_addon_charges e têm
// endpoint próprio (GET /my-addon-charges), só o registro local, sem gateway.
export function fetchAddonCharges(filters) {
  return dispatch => {
    dispatch(action(FETCH_ADDON_CHARGES.ACTION))
    return axios
      .get(`${config.API_URL}/my-addon-charges`, { params: filters })
      .then(resp => {
        dispatch(action(FETCH_ADDON_CHARGES.SUCCESS, { data: resp.data }))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_ADDON_CHARGES, e)))
  }
}

// Detalhe de uma cobrança de pró-rata: traz o bloco `payment`, buscado na hora
// no Pagar.me (boleto/cartão vivos). Pode vir 200 com `payment: null` quando o
// gateway não responde — não é falha, a tela precisa aguentar esse caso.
export function fetchAddonCharge(id) {
  return dispatch => {
    dispatch(action(FETCH_ADDON_CHARGE.ACTION))
    return axios
      .get(`${config.API_URL}/my-addon-charges/${id}`)
      .then(resp => {
        dispatch(action(FETCH_ADDON_CHARGE.SUCCESS, { data: resp.data }))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_ADDON_CHARGE, e)))
  }
}

export function fetchMyAddons() {
  return dispatch => {
    dispatch(action(FETCH_MY_ADDONS.ACTION))
    return axios
      .get(`${config.API_URL}/my-addons`)
      .then(resp => {
        dispatch(action(FETCH_MY_ADDONS.SUCCESS, { data: resp.data }))
        return resp.data
      })
      .catch(e => dispatch(actionFailed(FETCH_MY_ADDONS, e)))
  }
}

// `quantity` é a quantidade JÁ na contratação: contratar 1 e depois alterar
// para N geraria duas cobranças de pró-rata (dois boletos) para uma intenção só.
// Se o add-on já estiver contratado, a API acumula (tinha 2, contrata 3, fica 5).
export function contractAddon(addonServiceId, quantity = 1) {
  return dispatch => {
    dispatch(action(CONTRACT_ADDON.ACTION))
    return axios
      .post(`${config.API_URL}/my-addons`, {
        addon_service_id: addonServiceId,
        quantity,
      })
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CONTRACT_ADDON.SUCCESS, data))
        dispatch(fetchMyAddons())
        dispatch(fetchPlanDetails())
        dispatch(revalidateAuthenticatedUser())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(CONTRACT_ADDON, e))
        return false
      })
  }
}

export function updateAddonQuantity(laundryClientAddonId, quantity) {
  return dispatch => {
    dispatch(action(UPDATE_ADDON_QUANTITY.ACTION))
    return axios
      .put(`${config.API_URL}/my-addons/${laundryClientAddonId}`, { quantity })
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_ADDON_QUANTITY.SUCCESS, data))
        dispatch(fetchMyAddons())
        dispatch(fetchPlanDetails())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(UPDATE_ADDON_QUANTITY, e))
        return false
      })
  }
}

export function cancelAddon(laundryClientAddonId) {
  return dispatch => {
    dispatch(action(CANCEL_ADDON.ACTION))
    return axios
      .delete(`${config.API_URL}/my-addons/${laundryClientAddonId}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CANCEL_ADDON.SUCCESS, data))
        dispatch(fetchMyAddons())
        dispatch(fetchPlanDetails())
        dispatch(revalidateAuthenticatedUser())
        return true
      })
      .catch(e => {
        dispatch(actionFailed(CANCEL_ADDON, e))
        return false
      })
  }
}

// ============================================================================
// ADMIN — gerência da assinatura de um cliente (lavanderia) específico.
// O admin não assina: apenas visualiza o plano/pagamento e mexe nos add-ons.
// ============================================================================

export const FETCH_CLIENT_SUBSCRIPTION = createAsyncConst(
  'FETCH_CLIENT_SUBSCRIPTION'
)
export const FETCH_ADDON_CATALOG = createAsyncConst('FETCH_ADDON_CATALOG')
export const CONTRACT_CLIENT_ADDON = createAsyncConst('CONTRACT_CLIENT_ADDON')
export const CANCEL_CLIENT_ADDON = createAsyncConst('CANCEL_CLIENT_ADDON')
export const CANCEL_CLIENT_ADDON_IMMEDIATE = createAsyncConst(
  'CANCEL_CLIENT_ADDON_IMMEDIATE'
)
export const UPDATE_CLIENT_ADDON_DISCOUNT = createAsyncConst(
  'UPDATE_CLIENT_ADDON_DISCOUNT'
)
export const UPDATE_CLIENT_ADDON_QUANTITY = createAsyncConst(
  'UPDATE_CLIENT_ADDON_QUANTITY'
)

export function fetchClientSubscription(laundryClientId) {
  return dispatch => {
    dispatch(action(FETCH_CLIENT_SUBSCRIPTION.ACTION))
    return axios
      .get(`${config.API_URL}/laundry-client/${laundryClientId}/subscription`)
      .then(resp => {
        dispatch(action(FETCH_CLIENT_SUBSCRIPTION.SUCCESS, { data: resp.data }))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_CLIENT_SUBSCRIPTION, e)))
  }
}

export function fetchAddonCatalog() {
  return dispatch => {
    dispatch(action(FETCH_ADDON_CATALOG.ACTION))
    return axios
      .get(`${config.API_URL}/addon-services`)
      .then(resp => {
        dispatch(action(FETCH_ADDON_CATALOG.SUCCESS, { data: resp.data }))
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_ADDON_CATALOG, e)))
  }
}

// idem contractAddon: `quantity` na contratação evita uma segunda cobrança de
// pró-rata só para ajustar a quantidade logo depois
export function contractClientAddon(
  laundryClientId,
  addonServiceId,
  discountPercentage = 0,
  quantity = 1
) {
  return dispatch => {
    dispatch(action(CONTRACT_CLIENT_ADDON.ACTION))
    return axios
      .post(`${config.API_URL}/laundry-client/${laundryClientId}/addons`, {
        addon_service_id: addonServiceId,
        discount_percentage: discountPercentage,
        quantity,
      })
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CONTRACT_CLIENT_ADDON.SUCCESS, data))
        dispatch(fetchClientSubscription(laundryClientId))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(CONTRACT_CLIENT_ADDON, e))
        return false
      })
  }
}

export function cancelClientAddon(laundryClientAddonId, laundryClientId) {
  return dispatch => {
    dispatch(action(CANCEL_CLIENT_ADDON.ACTION))
    return axios
      .delete(`${config.API_URL}/laundry-client-addons/${laundryClientAddonId}`)
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CANCEL_CLIENT_ADDON.SUCCESS, data))
        dispatch(fetchClientSubscription(laundryClientId))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(CANCEL_CLIENT_ADDON, e))
        return false
      })
  }
}

export function cancelClientAddonImmediate(
  laundryClientAddonId,
  laundryClientId
) {
  return dispatch => {
    dispatch(action(CANCEL_CLIENT_ADDON_IMMEDIATE.ACTION))
    return axios
      .delete(
        `${config.API_URL}/laundry-client-addons/${laundryClientAddonId}/immediate`
      )
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(CANCEL_CLIENT_ADDON_IMMEDIATE.SUCCESS, data))
        dispatch(fetchClientSubscription(laundryClientId))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(CANCEL_CLIENT_ADDON_IMMEDIATE, e))
        return false
      })
  }
}

export function updateClientAddonDiscount(
  laundryClientAddonId,
  discountPercentage,
  laundryClientId
) {
  return dispatch => {
    dispatch(action(UPDATE_CLIENT_ADDON_DISCOUNT.ACTION))
    return axios
      .put(
        `${config.API_URL}/laundry-client-addons/${laundryClientAddonId}/discount`,
        { discount_percentage: discountPercentage }
      )
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_CLIENT_ADDON_DISCOUNT.SUCCESS, data))
        dispatch(fetchClientSubscription(laundryClientId))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(UPDATE_CLIENT_ADDON_DISCOUNT, e))
        return false
      })
  }
}

export function updateClientAddonQuantity(
  laundryClientAddonId,
  quantity,
  laundryClientId
) {
  return dispatch => {
    dispatch(action(UPDATE_CLIENT_ADDON_QUANTITY.ACTION))
    return axios
      .put(`${config.API_URL}/laundry-client-addons/${laundryClientAddonId}`, {
        quantity,
      })
      .then(resp => resp.data)
      .then(data => {
        dispatch(action(UPDATE_CLIENT_ADDON_QUANTITY.SUCCESS, data))
        dispatch(fetchClientSubscription(laundryClientId))
        return true
      })
      .catch(e => {
        dispatch(actionFailed(UPDATE_CLIENT_ADDON_QUANTITY, e))
        return false
      })
  }
}

export function fetchSignatureStatus() {
  return dispatch => {
    dispatch(action(FETCH_SUBSCRIPTION_STATUS.ACTION, {}, false, false))
    return axios
      .get(`${config.API_URL}/subscription-status`)
      .then(resp => {
        dispatch(
          action(
            FETCH_SUBSCRIPTION_STATUS.SUCCESS,
            {
              data: resp.data,
            },
            false,
            false
          )
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_SUBSCRIPTION_STATUS, e)))
  }
}
